import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common'; // needed for *ngIf, *ngFor
import { Router, ActivatedRoute } from '@angular/router';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { TagsLanguageService } from '../../features/tags-language/tagsLanguage.service';
import { ToastrService } from 'ngx-toastr';
import { ColoringImageService } from '../../features/coloring-image/coloring-image.service';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ConfirmDialog } from '../../shared/components/confirm-dialog/confirm-dialog';
import { NoDataComponent } from '../../shared/components/no-data/nodata.component';
import { ContentLoaderComponent } from '../../shared/components/content-loader-component/contentLoader.component';
import { PermissionDirective } from '../../shared/components/directives/permissions.directives';

@Component({
  selector: 'app-coloring-image',
  standalone: true,
  imports: [CommonModule, MatDialogModule, NoDataComponent, ContentLoaderComponent,PermissionDirective],
  templateUrl: './coloring-image.component.html',
  styleUrls: ['./coloring-image.component.scss']
})
export class ColoringImageComponent {
  readonly dialog = inject(MatDialog);
  public coloringImageList: any[] = [];
  public languages: any[] = [];
  public langCode: string = '';
  private searchSubject = new Subject<string>();
  noData = false;
  loading = false;
  searchTerm: string = '';

  constructor(
    private router: Router,
    private tagsService: TagsLanguageService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private coloringImageService: ColoringImageService
  ) { }

  ngOnInit() {
    this.getAllColoringImages(this.langCode);
    this.searchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.getAllColoringImages(this.langCode, searchTerm);
      });
  }

  getLanguages(): void {
    this.tagsService.getLangauges().subscribe({
      next: (res) => {
        if (res?.data) this.languages = res?.data;
      },
      error: (err) => console.log(err),
    });
  }

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    this.searchSubject.next(input.value);
  }

  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = 'assets/images/placeHolderImage.jpg';
  }

  getAllColoringImages(lang: any, search = ''): void {
    this.loading = true;
    this.coloringImageService.getAllColoringImage(lang, search).subscribe({
      next: (res) => {
        this.coloringImageList = res?.data || [];
        this.noData = this.coloringImageList.length === 0;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
      },
    });
  }

  onAddColoringImage() {
    this.router.navigate(['/coloring-images/new']);
  }

  deleteColoringImage(id: any): void {
    const dialogRef = this.dialog.open(ConfirmDialog);

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.coloringImageService.deleteColoringImage(id).subscribe({
          next: (res) => {
            this.toastr.success(res?.message || 'Deleted successfully');
            this.getAllColoringImages(this.langCode);
          },
          error: (err) => console.log(err),
        });
      }
    });
  }

  getEnglishTitle(translations: any[]): string {
    if (!translations || translations.length === 0) return 'Untitled';
    const englishTranslation = translations.find(t => t.langId === 1);
    return englishTranslation?.title?.slice(0, 40) || translations[0]?.title?.slice(0, 40) || 'Untitled';
  }

  onEditColoringImage(id: any) {
    this.router.navigate([`/coloring-images/edit/${id}`]);
  }
}
